import {create} from 'zustand'
import {persist} from 'zustand/middleware'

export const useNavbar = create(
  persist(
    (set, get) => ({
      isNavbarCollapsed: false,
      auditAI: {
        processing: false,
        done: false,
        auditID: '',
      },
      buttonPosition: null,
      setButtonPosition: ref => set({buttonPosition: ref}),
      toggleNavbar: () => set(state => ({isNavbarCollapsed: !get().isNavbarCollapsed})),
      setAuditAI: values => set(state => ({auditAI: {...get().auditAI, ...values}})),
    }),
    {
      name: 'navbar-store',
    }
  )
)
